/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type QrCodeShow_lists$ref: FragmentReference;
declare export opaque type QrCodeShow_lists$fragmentType: QrCodeShow_lists$ref;
export type QrCodeShow_lists = {|
  +id: string,
  +qrCodes: {|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +createdAt: any,
        +link: string,
        +sign: string,
      |}
    |}>
  |},
  +$refType: QrCodeShow_lists$ref,
|};
export type QrCodeShow_lists$data = QrCodeShow_lists;
export type QrCodeShow_lists$key = {
  +$data?: QrCodeShow_lists$data,
  +$fragmentRefs: QrCodeShow_lists$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "QrCodeShow_lists",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 100
        }
      ],
      "concreteType": "QrCodeConnection",
      "kind": "LinkedField",
      "name": "qrCodes",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "QrCodeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "QrCode",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "createdAt",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "link",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "sign",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "qrCodes(first:100)"
    }
  ],
  "type": "Lists"
};
})();
// prettier-ignore
(node/*: any*/).hash = '97d4c0269ed3180e22944074dfca0524';

module.exports = node;
